export const PortalsConfigurationPermissions = {
  ViewPortalsConfiguration :  {
    components: null ,  
    componentsId: null , 
    permissionsId: 'e259e49f-f03f-437e-db0b-08dbf16cf01d' , 
    permissionsName: 'View Portals Configuration'  ,  
  }
};
